module.exports = __webpack_public_path__ + "img/nominativas.1a853320.png";